import React, { FC } from 'react';
import { Button, List, Popover, Row } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import HyperLink from '../common/HyperLink';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';

const WorkOrderTaskButton = ({ task, locationId, userType }): React.ReactElement => {
	const allUrl = `/${userType}/workOrders/overview/all?siteSurveyTaskTitleId=${task.titleId}&locationIds=${locationId}`;
	const activeUrl = `/${userType}/workOrders/overview/all?siteSurveyTaskTitleId=${task.titleId}&locationIds=${locationId}&displayStatuses=Pending%2CDeferred%2COpen%2CInProgress%2COnHold`;
	return (
		<Row>
			{nullSafeGetOrElse('openWorkOrderCountAcrossWalkthroughs', task, 0) > 0 ? (
				<Popover
					content={`${nullSafeGet('openWorkOrderCountAcrossWalkthroughs', task)} open work order${
						nullSafeGetOrElse('openWorkOrderCountAcrossWalkthroughs', task, 0) > 1 ? 's' : ''
					} created from this task across all walkthroughs.`}
				>
					<Link to={activeUrl}>
						<Button style={{ marginRight: 16 }} type={'default'}>
							Open Work Order
							{nullSafeGetOrElse('openWorkOrderCountAcrossWalkthroughs', task, 0) > 1 ? 's' : ''} (
							{nullSafeGet('openWorkOrderCountAcrossWalkthroughs', task)})
						</Button>
					</Link>
				</Popover>
			) : null}
			{nullSafeGetOrElse('totalWorkOrderCountAcrossWalkthroughs', task, 0) > 0 ? (
				<Popover
					content={`${nullSafeGet('totalWorkOrderCountAcrossWalkthroughs', task)} total work order${
						nullSafeGetOrElse('totalWorkOrderCountAcrossWalkthroughs', task, 0) > 1 ? 's' : ''
					} created from this task across all walkthroughs.`}
				>
					<Link to={allUrl}>
						<Button style={{ marginRight: 16 }} type={'default'}>
							All Work Order
							{nullSafeGetOrElse('totalWorkOrderCountAcrossWalkthroughs', task, 0) > 1 ? 's' : ''} (
							{nullSafeGet('totalWorkOrderCountAcrossWalkthroughs', task)})
						</Button>
					</Link>
				</Popover>
			) : null}
		</Row>
	);
};

const mapStateToProps = (state, ownProps) => ({
	userType: state.session.userType,
	featureFlags: state.session.featureFlags,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderTaskButton);
